function getParameterByName(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name) || '';
}

$(document).ready(function() {
    const fields = {
        last_name: '#last_name',
        name: '#name',
        middle_name: '#middle_name',
        phone: '#phone',
        email: '#email',
        shipping_postcode: '#shipping_postcode',
        shipping_state: '#shipping_state',
        shipping_city: '#shipping_city',
        shipping_address: '#shipping_address',
        comment: '#comment',
        promo_code: '#promo_code',
    };

    $.each(fields, function(param, selector) {
        const value = getParameterByName(param);
        const $display = $(selector + '_display');
        const $hidden = $(selector + '_hidden');

        // Заполняем только если данные пришли в URL (fallback) и поле ещё пустое
        if (value && !$display.text().trim()) {
            $display.text(value);
            $hidden.val(value);
        }
    });
});
